import React from "react";
import { Route, RouteProps } from "react-router-dom";
import { Address } from "@origin-digital/address-lookup";
import {
  ProfileFieldMapTypes,
  isBroadbandOnlyCustomer,
} from "../../crm/profileFieldMapContextHelpers";
import {
  FIELD_UPDATE_HOOK_UNSUPPORTED,
  FieldUnsupported,
  FieldUpdateHook,
  FieldUpdateHookUnsupported,
} from "../../crm/profileFieldMap";
import { AddressProp } from "../../screens/UpdateAddress";
import { ContactPreferenceProp } from "../../screens/UpdateContactPrefsScreen/ContactOption";
import { isContactPreferencesRoute } from "../../consts";

type ValidFieldMapData =
  | string
  | AddressProp[]
  | ContactPreferenceProp[]
  | null;
type ValidFieldMapUseUpdate =
  | FieldUpdateHook<string>
  | FieldUpdateHook<Address>
  | FieldUpdateHook<ContactPreferenceProp>
  | FieldUpdateHookUnsupported;

export interface IValidRouteProps extends RouteProps {
  type: ProfileFieldMapTypes;
  fieldMap:
    | {
        data: ValidFieldMapData;
        editable: boolean;
        useUpdate: ValidFieldMapUseUpdate | FieldUpdateHookUnsupported;
      }
    | FieldUnsupported;
  // render prop delays fieldMap property access until after validation
  screen: (
    data: ValidFieldMapData,
    useUpdate: ValidFieldMapUseUpdate,
    type: ProfileFieldMapTypes
  ) => JSX.Element;
}

export const ValidEditableFieldRoute = (props: IValidRouteProps) => {
  const { type, fieldMap, ...routerProps } = props;

  // If it's BROADBAND only, we only render the contact preferences route
  if (isBroadbandOnlyCustomer(type)) {
    if (isContactPreferencesRoute(routerProps.path)) {
      return (
        <Route {...routerProps}>
          {props.screen([], FIELD_UPDATE_HOOK_UNSUPPORTED, type)}
        </Route>
      );
    }
    return null; // Do not render other routes for broadband only profile
  }

  if (!fieldMap || !fieldMap.editable || !fieldMap.useUpdate) {
    throw new Error(
      `Route access ${routerProps.path} but is not editable for ${type}`
    );
  }
  return (
    <Route {...routerProps}>
      {props.screen(fieldMap.data, fieldMap.useUpdate, type)}
    </Route>
  );
};
